import UserService from "./UserService"
import ExerciciService from "./ExerciciService"
import MetodologiaService from "./MetodologiaService"
import PlanificacioService from "./PlanificacioService"
import ProgressioService from "./ProgressioService"
import ObjectiuService from "./ObjectiuService"
import MesocicleService from "./MesocicleService"
import AmbitEspecificService from "./AmbitEspecificService"
import AmbitGeneralService from "./AmbitGeneralService"
import ElementTecnicTacticService from "./ElementTecnicTacticService"
import MaterialUsatService from "./MaterialUsatService"
import NivellService from "./NivellService"
import NombreParticipantService from "./NombreParticipantService"
import QualitatFisicaBasicaService from "./QualitatFisicaBasicaService"
import QualitatPsicomotriuService from "./QualitatPsicomotriuService"
import TipusExerciciService from "./TipusExerciciService"
import SessioService from "./SessioService"

import AuthService from "./AuthService"

const services = {}
for (const service of [
  UserService,
  ExerciciService,
  MetodologiaService,
  AuthService,
  PlanificacioService,
  ProgressioService,
  ObjectiuService,
  MesocicleService,
  AmbitEspecificService,
  AmbitGeneralService,
  ElementTecnicTacticService,
  MaterialUsatService,
  NivellService,
  NombreParticipantService,
  QualitatFisicaBasicaService,
  QualitatPsicomotriuService,
  TipusExerciciService,
  SessioService,
]) {
  const name = service.name()
  services[name] = service
}

export default {
  get: name => services[name],
}
